/**
 * Moved to `shared/src/review/review-estimate-basis.ts` so the review surface and the server-side
 * export read one copy of this wording. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export { estimateMovementSentence } from '@taptimize/shared/dist/review/review-estimate-basis';
